export default __webpack_public_path__ + "static/media/amanda.dae1da46.jpg";